import React, { Component } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const StyledImageSlider = styled.div`
  margin: 0 auto 47px auto;
  max-width: ${p => p.theme.globalWidthSmall};
`;
const Slide = styled.div`
  background-color: ${p => p.theme.colors.white};
  background-image: ${p => (p.url ? `url(${p.url})` : 'none')};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: grab;
  padding-bottom: 66%;
  width: 100%;
  height: 75%;

  &:active {
    cursor: grabbing;
  }
`;

class ImageSlider extends Component {
  state = {
    images: []
  };

  componentDidMount() {
    this.props.images.map(imgSrc => {
      const image = new Image();
      image.src = imgSrc;

      image.onload = () =>
        this.setState({
          images: [...this.state.images, imgSrc]
        });

      return null;
    });
  }

  render() {
    const sliderSettings = {
      arrows: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <StyledImageSlider>
        <Slider {...sliderSettings}>
          {this.state.images.map(imgSrc => (
            <Slide key={imgSrc} url={imgSrc} />
          ))}
        </Slider>
      </StyledImageSlider>
    );
  }
}

export default ImageSlider;

function NextArrow({ className, style, onClick }) {
  return (
    <div
      className={className}
      style={{ ...style, right: '20px', zIndex: 1, display: 'block' }}
      onClick={onClick}
    />
  );
}

function PrevArrow({ className, style, onClick }) {
  return (
    <div
      className={className}
      style={{ ...style, left: '20px', zIndex: 1, display: 'block' }}
      onClick={onClick}
    />
  );
}
